import React,{useState} from 'react';
import {Eye,EyeOff} from 'lucide-react';
import {contactBlocked,contactScope} from './contact-names.mjs';
import {useLang} from './i18n';
export function BlockedContent({authorId,children}:{authorId?:string;children:React.ReactNode}){
 const [revealed,setRevealed]=useState<string|null>(null),[,,tr]=useLang(),scope=contactScope()+':'+authorId,visible=revealed===scope;
 if(!contactBlocked(authorId))return <>{children}</>;
 return <div className="blocked-content" onClick={e=>e.stopPropagation()}><button type="button" className="blocked-message-toggle" aria-expanded={visible} onClick={()=>setRevealed(visible?null:scope)}>{visible?<EyeOff size={15}/>:<Eye size={15}/>} {tr('Blocked message','Blockierte Nachricht')} · {visible?tr('Hide','Verbergen'):tr('Show','Anzeigen')}</button>{visible&&children}</div>;
}
